import styles from "./styles/conversion-effect-parameters.module.scss";
import TextButton from "@/components/common/text-button";
import useSelection from "@/hooks/use-selection";
import ParameterSlider from "@/components/pages/convert/components/parameter-slider";
import { useEffect, useState } from "react";
import { EffectTab } from "@/data/convert-effects.data";

type Props<TSettings> = {
  tab: EffectTab;
  settings: TSettings;
  handleResetEffectTabParametersClick: (tab: EffectTab) => void;
  handleEffectParameterValueChanged: (
    tabId: string,
    parameterId: string,
    value: number,
  ) => void;
};

const ConversionEffectParameters = <TSettings,>({
  tab,
  settings,
  handleResetEffectTabParametersClick,
  handleEffectParameterValueChanged,
}: Props<TSettings>) => {
  const [parameters, setParameters] = useState(tab.getParameters());

  const [titleBlockWidths, setTitleBlockWidths] = useState<{
    [id: string]: number;
  }>({});

  const [maxTitleBlockWidth, setMaxTitleBlockWidth] = useState<
    number | undefined
  >();

  const { toggleSelection, toggleAllSelections, isAllSelected, isAnySelected } =
    useSelection(parameters);

  useEffect(() => {
    const keys = Object.keys(titleBlockWidths);
    const isEveryKeyMatching = keys.every((key) =>
      parameters.some((parameter) => parameter.id === key),
    );

    if (keys.length === parameters.length && isEveryKeyMatching) {
      const values = keys.map((key) => titleBlockWidths[key]);
      setMaxTitleBlockWidth(Math.max(...values));
    } else {
      setMaxTitleBlockWidth(undefined);
    }
  }, [titleBlockWidths]);

  useEffect(() => {
    setParameters(tab.getParameters());
  }, [settings, tab]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header_wrapper}>
        {/*<SelectAllButton*/}
        {/*  isChecked={isAllSelected}*/}
        {/*  handleCheck={toggleAllSelections}*/}
        {/*/>*/}
        <TextButton
          isEnabled={true}
          // isEnabled={isAnySelected}
          text="Reset"
          textColor="#E64C4C"
          textPointeroverColor="#E64C4C"
          handleClick={() => handleResetEffectTabParametersClick(tab)}
        />
      </div>
      <div className={styles.parameters_container}>
        {parameters.map((parameter) => (
          <ParameterSlider
            key={parameter.id}
            maxTitleBlockWidth={maxTitleBlockWidth}
            setTitleBlockWidth={(value: number) =>
              setTitleBlockWidths((prevState) => ({
                ...prevState,
                [parameter.id]: value,
              }))
            }
            parameter={parameter}
            handleChecked={() => toggleSelection(parameter.id)}
            handleValueChanged={(value) =>
              handleEffectParameterValueChanged(tab.id, parameter.id, value)
            }
          />
        ))}
      </div>
    </div>
  );
};

export default ConversionEffectParameters;
